import { useEffect, useState, useContext } from "react"

import { withStyles } from '@material-ui/core/styles'
import styles from '../../TabStyles'

import { apiUrl } from "../../../../ui-utils/apiConfig"
import { httpRequest } from '../../../../ui-utils/api'
import EditIcon from '@mui/icons-material/Edit'
import snackError from "../../../../helpers/snackError"
import { reducerContext } from "../../../../contextApi's/contextApi's"
import {
  Grid,Typography, TextField, Button, FormControl,
  IconButton, Modal, FormHelperText,
  Select, MenuItem, Table, TableContainer, TableHead, TableRow, TableCell, TableBody, Checkbox, ListItemText, Popper
} from '@mui/material'
import axios from 'axios'
import { TablePagination } from "@material-ui/core" // added by srini on 16-01-25

const Roles = ({ classes }) => {
   const { dispatch } = useContext(reducerContext)
    const [addRolesModal, setAddRolesModal] = useState(false)
    const [newName , setNewName] = useState("")
    const [description , setDescription] = useState("")
    const [errType , setErrType] = useState(0)
    const [errMsg , setErrMsg] = useState("")
    const [editRole , setEditRole] = useState(false)
    const [additionalError , setAdditionalError] = useState(false)
    const [additionalRoles , setAdditionalRoles] = useState([])
    const [menuData , setMenuData] = useState([])
    const [roleData , setRoleData] = useState([])
    const [uid , setUid] = useState(0)
    // added by srini on 16-01-25
    const [rowsPerPage, setRowsPerPage] = useState(10)
    const [page, setPage] = useState(0)

    useEffect(()=>{
      (async () => {try {
        const roledata = await httpRequest({
          endPoint: `${apiUrl.roleList}`,
          method: "get",
          instance: "instanceOne",
        })
        if (roledata?.data?.success === true) {
          setRoleData(roledata?.data?.result)
        }
        // Dev Srini 25/10/24
        else if (roledata.success === false) {
          console.log('Error in Role List API', roledata)
        }
    }
    catch (error) {
        console.log('Error in Role List API', error)
    }
  })()
},[])


useEffect(()=>{
  (async() =>{
    try {
      const menudata = await httpRequest({
        endPoint: `${apiUrl.menuList}`,
        method: "get",
        instance: "instanceOne",
      })
      if (menudata?.data?.success === true) {
        setMenuData(menudata?.data?.result)
      }
      else{
        console.log('Error in Menu List API', menudata)
      }
  }
  catch (error) {
    console.log('Error in Menu List API', error)
  }})()
},[])


    const handleOpenAddRoles = () =>{
        setAddRolesModal(true)
    }

    const handleCloseRole = () =>{
      setAddRolesModal(false)
      setEditRole(false)
      setNewName("")
      setDescription("")
      setErrMsg("")
      setAdditionalRoles([0])
      setAdditionalError(false)
    }

    const handleAdditionalRoles = (e) =>{
      setAdditionalRoles(e.target.value)
      console.log(e.target.value)

    }
  
    const handleEditRoleModal = (data) =>{
      console.log("data",data.uid)
        setAddRolesModal(true)
        setEditRole(true)
        setNewName(data.name)
        setDescription(data.description)
        setAdditionalRoles(data.menus)
        setUid(data.uid)
    }

    const handleEditRole = async () =>{
        let isok = 0

        if (!newName.length && isok === 0) {

            isok = 1
            setErrType(1)
            setErrMsg("Enter the name")

        }

        if (!description.length && isok === 0) {

            isok = 2
            setErrType(2)
            setErrMsg("Enter the Description")

        }

        if(isok === 0) {
        if (additionalRoles == 0) {
            setAdditionalError(true)
        }

          else if (additionalRoles) {
            setAdditionalError(false)

            let newrole = {
              name: newName,
              description: description,
              menus: additionalRoles,
              uid: uid
          }
          
          console.log(newrole)
          try{
            const editroledata = await httpRequest({
              endPoint: `${apiUrl.roleEdit}`,
              method: "put",
              instance: "instanceOne",
              requestBody: newrole,
            })

            if (editroledata?.data?.success === true) {
              setAddRolesModal(false)
              setEditRole(false)
              setNewName("")
              setDescription("")
              setAdditionalRoles([0])
              setAdditionalError(false)
              setErrMsg("")

              const editedroletUid = editroledata?.data?.result.uid

              const updatedroleData = roleData.map(role =>{
                  if(role.uid === editedroletUid){
                    return editroledata?.data?.result
                  }
                  return role
              })
              setRoleData(updatedroleData)
              dispatch({
                type: 'SET_SHOW_ERROR',
                payload: true
              })

              dispatch({
                type: 'SET_ERROR',
                payload: 'Role Edit Success.'
              })
            dispatch({ type: 'SET_MY_SNACK', payload: snackError.mySucc })
          }
          else{
              console.log('Error in Role Edit API', editroledata)
              dispatch({
                type: 'SET_SHOW_ERROR',
                payload: true
              })

              dispatch({
                type: 'SET_ERROR',
                payload: 'Error in Role Edit.'
              })

              dispatch({ type: 'SET_MY_SNACK', payload: snackError.myError })
          }
          }catch(error){
            console.log('Error in Role Edit API', error)
            dispatch({
              type: 'SET_SHOW_ERROR',
              payload: true
            })

            dispatch({
              type: 'SET_ERROR',
              payload: 'Error in Role Edit.'
            })

            dispatch({ type: 'SET_MY_SNACK', payload: snackError.myError })
          }
          }
        }
    }

    const handleCreateNewRole = async () =>{
  
        let isok = 0

        if (!newName.length && isok === 0) {
            isok = 1
            setErrType(1)
            setErrMsg("Enter the Name")
        }

        if (!description.length && isok === 0) {
            isok = 2
            setErrType(2)
            setErrMsg("Enter the Description")
        }

        if (isok === 0) {
            if (additionalRoles == 0) {
                setAdditionalError(true)
            }
            else if (additionalRoles) {
                setAdditionalError(false)
                let newrole = {
                    name: newName,
                    menus: additionalRoles,
                    description: description
                }
                try {

                  const newroledata = await httpRequest({
                    endPoint: `${apiUrl.roleCreate}`,
                    method: "post",
                    instance: "instanceOne",
                    requestBody: newrole,

                  })
                  if (newroledata?.data?.success === true) {
                    setRoleData([...roleData, newroledata?.data?.result])
                        setNewName("")
                        setDescription("")
                        setAdditionalRoles([])
                        setAddRolesModal(false)
                        setAdditionalError(false)
                        setErrMsg("")

                    dispatch({
                      type: 'SET_SHOW_ERROR',
                      payload: true
                    })

                    dispatch({
                      type: 'SET_ERROR',
                      payload: 'Role created Successfully.'
                    })
                    dispatch({ type: 'SET_MY_SNACK', payload: snackError.mySucc })
                    }


                    else{
                      console.log('Error in Role Create API', newroledata)
                    dispatch({
                      type: 'SET_SHOW_ERROR',
                      payload: true
                    })

                    dispatch({
                      type: 'SET_ERROR',
                      payload: 'Error in Role create.'
                    })

                    dispatch({ type: 'SET_MY_SNACK', payload: snackError.myError })
                    }
                }
                catch (error) {
                  console.log('Error in Role Create API', error)
                }

            }
        }
    }

  // added by srini on 16-01-25
  const handlePageChange = (event, newpage) => {
    setPage(newpage)
  }
  const handleRowsPerPageChange = (event) => {
    setRowsPerPage(+event.target.value)
    setPage(0)
  }


  return (
    <div style={{ flex: '82%', marginLeft: '2%',height:"100vh" }}>
      <Typography
        className={classes.dashboardText2}
        style={{ color: "#FFFFFF", marginTop: "8%" }}
      >
        Roles
      </Typography>
      <Button
        style={{
          width: "172px",
          height: "20px",
          border: "2px solid red",
          margin: '1% 0 1% 78%'
        }}
      >
        <span
          className={classes.addUserText}
          style={{ textTransform: "none" }}
          onClick={handleOpenAddRoles}
        >
          {" "}
          Add New Roles{" "}
        </span>
      </Button>
      <Modal
        className={classes.modalCard2}
        open={addRolesModal}
        style={{ marginLeft: "420px", marginTop: "190px" }}
        BackdropProps={{
          style: {
            backgroundColor: "rgba(0, 0, 0, 0)",
          },
        }}
      >
        <div>
          <img
            src={require("../../../../ui-assets/XFrame.png")}
            alt=" X Icon"
            onClick={handleCloseRole}
            style={{
              width: "24px",
              height: "24px",
              flexShrink: "0",
              marginLeft: "495px",
              marginTop: "23px",
              cursor: "pointer",
            }}
          />
          <Grid Container style={{ marginLeft: "100px", marginTop: "10px" }}>
            <Grid item>
              <Typography
                className={classes.formlabel1}
                style={{ paddingTop: "10px" }}
              >
                Name
              </Typography>
              <FormControl>
                <TextField
                  value={newName}
                  placeholder="Enter name"
                  InputProps={{
                    style: {
                      width: "342px ",
                      height: "42px ",
                      backgroundColor: "white",
                      flexShrink: 0,
                      color: "black",
                      fontFamily: "cardiuma-regular",
                      fontSize: "12px",
                      fontStyle: "normal",
                      fontWeight: "400",
                      lineHeight: "20px",
                    },
                  }}
                  onChange={(e) =>{
                    setNewName(e.target.value)
                    setErrType(0)
                  }}
                />
                {errType === 1 && (
                  <FormHelperText
                    className={classes.errtxt}
                    id="component-error-text"
                  >
                    {errMsg}
                  </FormHelperText>
                )}
              </FormControl>
            </Grid>

            {/* <Grid item>
              <FormControl>
                <Typography
                  className={classes.formlabel1}
                  style={{
                    paddingTop: "8px",
                    paddingRight: "10px",
                    color: additionalError ? "red" : "#333333",
                  }}
                >
                  Additional role
                </Typography>
                <Select
                  displayEmpty
                  variant="outlined"
                  
                  size="small"
                  value={additionalRoles}
                  placeholder="Select..."
                  style={{ height: "41px", width: "342px" }}
                  inputProps={{
                    style: {
                      fontSize: "14px",
                      background: "#ffffff",
                      height: "20px",
                    },
                  }}
                  option
                  onChange={handleAdditionalRoles}
                >
                  <MenuItem
                    value="0"
                    className={classes.inputtext1}
                  >
                    Select...
                  </MenuItem>

                  {menuData.map((item) => (
                    <MenuItem
                      key={item.uid}
                      value={item.uid}
                      className={classes.inputtext1}
                    >
                      {item.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid> */}

            <Grid item>
              <FormControl>
                <Typography
                  className={classes.formlabel1}
                  style={{
                    paddingTop: "8px",
                    paddingRight: "10px",
                    color: additionalError ? "red" : "#333333",
                  }}
                >
                  Additional role
                </Typography>
                <Select
                  multiple
                  displayEmpty
                  variant="outlined"
                  size="small"
                  value={additionalRoles}
                  onChange={handleAdditionalRoles}
                  style={{ height: "41px", width: "342px", background: "#ffffff" }}
                  renderValue={(selected) => {
                    if (selected.length === 0) {
                      return <em>Select...</em>;
                    }
                    return menuData
                      .filter((item) => selected.includes(item.uid))
                      .map((item) => item.name)
                      .join(", ");
                  }}
                  inputProps={{
                    sx: {
                      fontFamily: "cardiuma-regular",
                      fontSize: "14px",
                    },
                  }}
                  MenuProps={{
                    PaperProps: {
                      sx: {
                        maxHeight: 300,
                        width: 250,
                      },
                    },
                    MenuListProps: {
                      disableAutoFocusItem: true,
                    },
                   
                    PopperComponent: (props) => <Popper {...props} disablePortal placement="bottom-start" />,
                  }}
                >
                  {menuData.map((item) => (
                    <MenuItem key={item.uid} value={item.uid} className={classes.inputtext1}>
                      <Checkbox checked={additionalRoles.indexOf(item.uid) > -1} />
                      <ListItemText primary={item.name} />
                    </MenuItem>
                  ))}
                </Select>


              </FormControl>
            </Grid>

            <Grid item>
              <Typography
                className={classes.formlabel1}
                style={{ paddingTop: "10px" }}
              >
                Description
              </Typography>
              <FormControl>
                <TextField
                  value={description}
                  placeholder="Enter Description"
                  InputProps={{
                    style: {
                      width: "342px ",
                      height: "42px ",
                      backgroundColor: "white",
                      flexShrink: 0,
                      color: "black",
                      fontFamily: "cardiuma-regular",
                      fontSize: "12px",
                      fontStyle: "normal",
                      fontWeight: "400",
                      lineHeight: "20px",
                    },
                  }}
                  onChange={(e) => {
                      setDescription(e.target.value)
                      setErrType(0)
                    }}
                />
                {errType === 2 && (
                  <FormHelperText
                    className={classes.errtxt}
                    id="component-error-text"
                  >
                    {errMsg}
                  </FormHelperText>
                )}
              </FormControl>
            </Grid>

            <Button
              style={{
                backgroundColor: "#F3D45E",
                width: "136px",
                height: "42px",
                marginLeft: "90px",
                marginTop: "30px",
              }}
              onClick={editRole ? handleEditRole : handleCreateNewRole}
            >
              <span style={{ color: "#3E3E3E", textTransform: "none" }}>
                Save
              </span>
            </Button>
          </Grid>
        </div>
      </Modal>
      <div
        className={classes.horizantalTablayout}
      >
        <TableContainer>
          <Table sx={{ minWidth: 36 }} aria-label="simple table">
            <TableHead>
              {/* Srini - 12/11/24 */}
              <TableRow style={{ borderBottom: "2px solid Black" }}>
                <TableCell className={classes.tableHeading2} align="left">
                  UID
                </TableCell>
                <TableCell className={classes.tableHeading2} align="left">
                  Name
                </TableCell>
                <TableCell className={classes.tableHeading2} align="left">
                  Description
                </TableCell>
                <TableCell className={classes.tableHeading3} align="left">
                  Action
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {/* added by srini on 16-01-25 */}
              {roleData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((item, index) => (
                // Srini - 12/11/24
                <TableRow
                  key={index}
                  style={{ borderBottom: "2px solid Black" }}
                >
                  <TableCell align="left" className={classes.rowText}>
                    {item.uid}
                  </TableCell>
                  <TableCell align="left" className={classes.rowText}>
                    {item.name}
                  </TableCell>
                  <TableCell align="left" className={classes.rowText}>
                    {item.description}
                  </TableCell>

                  <TableCell align="left">
                    <IconButton onClick={() => handleEditRoleModal(item)
                      }>
                      <EditIcon
                        style={{ color: "#0083CA", fontSize: "18px" }}
                      />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        {/* added by srini on 16-01-25 */}
        <TablePagination
          className={classes.pagination}
          rowsPerPageOptions={[10, 15, 20]}
          component="div"
          count={roleData.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handlePageChange}
          onRowsPerPageChange={handleRowsPerPageChange}
        />
      </div>
    </div>
  )
}

export default withStyles(styles)(Roles)
